var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseErrorbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_close_errorbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.16736755,4.16736755 C4.39052429,3.94421082 4.75233285,3.94421082 4.97548959,4.16736755 L4.97548959,4.16736755 L8,7.192 L11.0245104,4.16736755 C11.222872,3.96900601 11.5307856,3.94696584 11.753492,4.10124704 L11.8326324,4.16736755 C12.0557892,4.39052429 12.0557892,4.75233285 11.8326324,4.97548959 L11.8326324,4.97548959 L8.808,8 L11.8326324,11.0245104 C12.030994,11.222872 12.0530342,11.5307856 11.898753,11.753492 L11.8326324,11.8326324 C11.6094757,12.0557892 11.2476671,12.0557892 11.0245104,11.8326324 L11.0245104,11.8326324 L8,8.808 L4.97548959,11.8326324 C4.77712804,12.030994 4.46921444,12.0530342 4.246508,11.898753 L4.16736755,11.8326324 C3.94421082,11.6094757 3.94421082,11.2476671 4.16736755,11.0245104 L4.16736755,11.0245104 L7.192,8 L4.16736755,4.97548959 C3.96900601,4.77712804 3.94696584,4.46921444 4.10124704,4.246508 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_close_errorbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape-Copy",
    fill: "#C60000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseErrorbox);
export default __webpack_public_path__ + "static/media/icon_close_errorbox.5792e4f41815c79da6ea088a63589b54.svg";
export { ForwardRef as ReactComponent };